function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

(function inkmergeRepairStalePages() {
  return;
  var path = window.location.pathname.replace(/\/$/, '');
  if (path !== '/pages/contact-inkmerge' && path !== '/pages/contact' && path !== '/pages/order-status' && path !== '/pages/track-your-order' && path !== '/pages/quality' && path !== '/pages/wash-test') return;

  var isTrack = path === '/pages/order-status' || path === '/pages/track-your-order';
  var isQuality = path === '/pages/quality' || path === '/pages/wash-test';
  var main = document.querySelector('main[role="main"]');
  if (!main) return;

  var footerWrap = main.querySelector('.wrapper--bottom');
  Array.from(main.children).forEach(function removeContent(child) {
    if (child !== footerWrap) child.remove();
  });

  var style = document.createElement('style');
  style.textContent = [
    '.im-js-route-page{--im-ink:#101010;--im-cloud:#f7f7f2;--im-blue:#2457ff;--im-lime:#c8ff2e;--im-graphite:#2b2b2b;background:var(--im-cloud);color:var(--im-ink);font-family:Inter,system-ui,sans-serif;padding-bottom:clamp(44px,7vw,90px)}',
    '.im-js-route-page__crumbs,.im-js-route-page__hero,.im-js-route-page__split,.im-js-route-page__grid,.im-js-route-page__faq{max-width:1180px;margin:0 auto;padding-inline:clamp(18px,4vw,40px)}',
    '.im-js-route-page__crumbs{padding-top:18px;display:flex;gap:8px;font-size:13px;color:rgba(16,16,16,.62)}',
    '.im-js-route-page__hero{padding-top:clamp(46px,7vw,92px);padding-bottom:clamp(26px,4vw,48px)}',
    '.im-js-route-page__eyebrow{margin:0 0 12px;color:var(--im-blue);font-size:12px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}',
    '.im-js-route-page h1,.im-js-route-page h2{margin:0;color:var(--im-ink);font-family:"Fraunces",Georgia,serif;letter-spacing:0;line-height:1.02}',
    '.im-js-route-page h1{font-size:clamp(44px,7vw,84px)}',
    '.im-js-route-page__hero p{max-width:720px;color:var(--im-graphite);font-size:17px;line-height:1.62}',
    '.im-js-route-page__split{display:grid;grid-template-columns:minmax(0,1fr) minmax(300px,.44fr);gap:clamp(18px,4vw,34px);align-items:start}',
    '.im-js-route-page__card{background:#fff;border:1px solid rgba(16,16,16,.14);padding:clamp(20px,4vw,32px)}',
    '.im-js-route-page__card--dark{background:var(--im-ink);color:#fff}',
    '.im-js-route-page__card--dark h2{color:#fff;font-size:clamp(28px,3vw,42px)}',
    '.im-js-route-page__card--dark ol{margin:20px 0;padding:0;display:grid;gap:14px;list-style:none}',
    '.im-js-route-page__card--dark li{display:grid;grid-template-columns:32px 1fr;gap:12px;align-items:center;color:rgba(255,255,255,.86)}',
    '.im-js-route-page__card--dark li span{width:32px;height:32px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:var(--im-blue);color:#fff;font-weight:900}',
    '.im-js-route-page__card--dark a{color:var(--im-lime);font-weight:900}',
    '.im-js-route-form{display:grid;gap:14px}',
    '.im-js-route-form label{display:flex;flex-direction:column;gap:6px;font-size:13px;font-weight:800}',
    '.im-js-route-form input,.im-js-route-form select,.im-js-route-form textarea{width:100%;min-height:44px;border:1px solid rgba(16,16,16,.2);background:var(--im-cloud);color:var(--im-ink);padding:11px 12px;font:inherit}',
    '.im-js-route-form textarea{min-height:120px;resize:vertical}',
    '.im-js-route-form button{min-height:48px;border:1px solid var(--im-ink);background:var(--im-blue);color:#fff;font-weight:900;cursor:pointer}',
    '.im-js-route-page__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1px;background:var(--im-ink)}',
    '.im-js-route-page__grid article{min-height:250px;background:#fff;padding:22px}',
    '.im-js-route-page__grid span{display:block;margin-bottom:34px;color:var(--im-blue);font-weight:900}',
    '.im-js-route-page__grid h2{font-size:25px}',
    '.im-js-route-page__grid p,.im-js-route-page__faq p{color:var(--im-graphite);font-size:17px;line-height:1.62}',
    '.im-js-route-page__faq{padding-top:clamp(42px,7vw,86px)}',
    '.im-js-route-page__faq h2{font-size:clamp(30px,4vw,56px)}',
    '.im-js-route-page__faq details{border-top:1px solid rgba(16,16,16,.14);padding:18px 0}',
    '.im-js-route-page__faq details:last-child{border-bottom:1px solid rgba(16,16,16,.14)}',
    '.im-js-route-page__faq summary{cursor:pointer;font-size:18px;font-weight:900}',
    '@media(max-width:900px){.im-js-route-page__split{grid-template-columns:1fr}.im-js-route-page__grid{grid-template-columns:repeat(2,minmax(0,1fr))}}',
    '@media(max-width:560px){.im-js-route-page__grid{grid-template-columns:1fr}}'
  ].join('');
  document.head.appendChild(style);

  var page = document.createElement('section');
  page.className = 'im-js-route-page im-js-route-page--' + (isQuality ? 'quality' : (isTrack ? 'track' : 'contact'));
  var pageHtml;
  if (isQuality) {
    pageHtml = [
      '<nav class="im-js-route-page__crumbs" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">/</span><span>Quality</span></nav>',
      '<header class="im-js-route-page__hero"><p class="im-js-route-page__eyebrow">Quality</p><h1>Quality checks before your order leaves InkMerge.</h1><p>InkMerge reviews artwork, placement, garment details, and order notes so original tees, custom prints, logo embroidery, and bulk quote requests move through the right production path.</p></header>',
      '<div class="im-js-route-page__grid" aria-label="Quality checkpoints">',
      '<article><span>01</span><h2>Artwork review</h2><p>Files are checked for obvious print or embroidery readiness issues before production details are finalized.</p></article>',
      '<article><span>02</span><h2>Order fit</h2><p>Ready-made designs can sell one piece. Embroidery and bulk custom print requests start at 12 pieces.</p></article>',
      '<article><span>03</span><h2>Placement notes</h2><p>Quote requests capture location, garment, quantity, and deadline details in structured fields.</p></article>',
      '<article><span>04</span><h2>Support path</h2><p>Questions can be sent through Help or the quote forms. We review requests and reply by email.</p></article>',
      '</div>',
      '<section class="im-js-route-page__faq" aria-labelledby="quality-js-faq-title"><p class="im-js-route-page__eyebrow">FAQ</p><h2 id="quality-js-faq-title">Quality questions</h2>',
      '<details><summary>Do ready-made designs require a minimum?</summary><p>No. Ready-made design products can be purchased one piece at a time.</p></details>',
      '<details><summary>Do embroidery and bulk orders require a minimum?</summary><p>Yes. Logo embroidery and bulk custom print quote requests start at 12 pieces.</p></details>',
      '<details><summary>Where should I send project details?</summary><p>Use the embroidery, bulk order, or custom studio request forms so the details are captured in a structured format.</p></details>',
      '</section>'
    ].join('');
  } else if (isTrack) {
    pageHtml = [
    '<nav class="im-js-route-page__crumbs" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">/</span><span>Track Your Order</span></nav>',
    '<header class="im-js-route-page__hero"><p class="im-js-route-page__eyebrow">Order status</p><h1>Track Your Order.</h1><p>Use the status link from your order or shipping email when you have it. If you cannot find that link, send your order details and InkMerge will help by email.</p></header>',
    '<div class="im-js-route-page__split"><div class="im-js-route-page__card">',
    '<form class="im-js-route-form" method="post" action="/contact#contact_form"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[request_type]" value="Order tracking help">',
    '<label><span>Email address</span><input type="email" name="contact[email]" autocomplete="email" required></label>',
    '<label><span>Order number</span><input type="text" name="contact[order_number]" autocomplete="off" required></label>',
    '<label><span>Anything else we should know?</span><textarea name="contact[body]" rows="5" placeholder="Add the product name, checkout email, or shipping question if helpful."></textarea></label>',
    '<button type="submit">Send tracking request</button></form></div>',
    '<aside class="im-js-route-page__card im-js-route-page__card--dark" aria-label="Order status timeline"><h2>Order timeline</h2><ol><li><span>1</span><strong>Order received</strong></li><li><span>2</span><strong>Artwork or proof review, when needed</strong></li><li><span>3</span><strong>Production path confirmed</strong></li><li><span>4</span><strong>Shipping status sent by email</strong></li></ol><a href="mailto:support@inkmerge.com">Email support</a></aside></div>'
    ].join('');
  } else {
    pageHtml = [
    '<nav class="im-js-route-page__crumbs" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">/</span><span>Contact</span></nav>',
    '<header class="im-js-route-page__hero"><p class="im-js-route-page__eyebrow">Contact</p><h1>Contact InkMerge.</h1><p>Questions about a design, quote, proof, order, logo embroidery, or bulk project? Send the details and InkMerge will reply by email.</p></header>',
    '<div class="im-js-route-page__split"><div class="im-js-route-page__card">',
    '<form class="im-js-route-form" method="post" action="/contact#contact_form"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[request_type]" value="General InkMerge contact">',
    '<label><span>Name</span><input type="text" name="contact[name]" autocomplete="name" required></label>',
    '<label><span>Email address</span><input type="email" name="contact[email]" autocomplete="email" required></label>',
    '<label><span>Topic</span><select name="contact[topic]" required><option value="Order question">Order question</option><option value="Customize Tee">Customize Tee</option><option value="Logo embroidery">Logo embroidery</option><option value="Bulk orders">Bulk orders</option><option value="Artwork or proof">Artwork or proof</option><option value="Other">Other</option></select></label>',
    '<label><span>Order or quote number, if any</span><input type="text" name="contact[order_or_quote_number]" autocomplete="off"></label>',
    '<label><span>Message</span><textarea name="contact[body]" rows="6" required placeholder="Include order details, artwork links, sizes, quantities, deadline notes, or anything else InkMerge should review."></textarea></label>',
    '<button type="submit">Send message</button></form></div>',
    '<aside class="im-js-route-page__card im-js-route-page__card--dark" aria-label="Helpful contact paths"><h2>Helpful paths</h2><ol><li><span>1</span><strong><a href="/pages/customize-tee?variant=53307956396326">Open Customize Tee</a></strong></li><li><span>2</span><strong><a href="/pages/logo-embroidery">Request embroidery quote</a></strong></li><li><span>3</span><strong><a href="/pages/bulk-orders">Request bulk quote</a></strong></li><li><span>4</span><strong><a href="/pages/track-your-order">Track an order</a></strong></li></ol><a href="mailto:support@inkmerge.com">support@inkmerge.com</a></aside></div>'
    ].join('');
  }
  page.innerHTML = pageHtml;

  if (footerWrap) {
    main.insertBefore(page, footerWrap);
  } else {
    main.appendChild(page);
  }
})();
